/**
 * Shared vehicle options for assistant onboarding and the dashboard's vehicle
 * settings. The API (`pulo_api/src/features/providers/validations.ts`) takes
 * any brand up to 100 characters and any year up to next year, so these lists
 * are suggestions — the brand field also accepts a typed value.
 */
export const VEHICLE_TYPES = ["Car", "SUV", "Van", "Bus", "Bike", "Boat"];

export const VEHICLE_BRANDS = [
  "Acura",
  "Audi",
  "BMW",
  "Chevrolet",
  "Ford",
  "Honda",
  "Hyundai",
  "Infiniti",
  "Innoson",
  "Jeep",
  "Kia",
  "Land Rover",
  "Lexus",
  "Mazda",
  "Mercedes",
  "Mitsubishi",
  "Nissan",
  "Peugeot",
  "Suzuki",
  "Toyota",
  "Volkswagen",
  "Volvo",
];

export const VEHICLE_BRAND_MAX_LENGTH = 100;

// Next year's models go on sale this year, and the API accepts them.
const newestVehicleYear = new Date().getFullYear() + 1;
const oldestVehicleYear = 2001;

export const VEHICLE_YEARS = Array.from(
  { length: newestVehicleYear - oldestVehicleYear + 1 },
  (_, i) => `${newestVehicleYear - i}`
);
